import Carousel from 'stimulus-carousel';

export default class extends Carousel {
  connect() {
    super.connect();
  }

  get defaultOptions() {
    return {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    };
  }
}
